import React from 'react';

import { type SmartMentionResource } from '@atlassian/smart-mention-resource';

type RovoMentionProvider = { value?: SmartMentionResource };
const initialState: RovoMentionProvider = {};

export const rovoMentionProviderDefaults = initialState;

const rovoMentionProvider = React.createContext<RovoMentionProvider>(initialState);
export const RovoMentionProvider = rovoMentionProvider.Provider;
export const useRovoMentionProvider = () => React.useContext(rovoMentionProvider);
